import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 26,
  medium: 19,
  small: 14,
  xSmall: 10
};
const PDFIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.22455 3H17.5127L23.9085 9.39692V25.771H6.22455V21.676H7.22455L7.22395 24.771H22.9079V10.104H16.8432V4H7.22395L7.22455 13.063H6.22455V3ZM17.8432 4.74434L22.2019 9.10378L17.8429 9.103L17.8432 4.74434Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.30762 18.2174V20H5.49438V15.3548H7.54374C8.87095 15.3548 9.12468 16.2136 9.12468 16.7926C9.12468 17.3716 8.87095 18.2174 7.54374 18.2174H6.30762ZM6.30762 17.5538H7.4982C7.86253 17.5538 8.31143 17.3716 8.31143 16.7861C8.31143 16.1745 7.9406 16.0184 7.51121 16.0184H6.30762V17.5538Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.7596 20C13.1909 20 13.8089 18.9591 13.8089 17.6774C13.8089 16.3957 13.1909 15.3548 11.7596 15.3548H9.83383V20H11.7596ZM10.6471 19.3364H11.4473C12.7224 19.3364 12.9957 18.6142 12.9957 17.6774C12.9957 16.7405 12.7224 16.0184 11.4473 16.0184H10.6471V19.3364Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement("path", { d: "M15.3443 20V17.9376H17.4457V17.274H15.3443V16.0574H17.7385V15.3548H14.5311V20H15.3443Z", fill: "currentColor" })
  );
};
PDFIcon.iconName = "PDFIcon";

export { PDFIcon };
